<template>
  <div class="edit-inspection-templates">
    <div>
      <h1>{{ $t('editInspectionTemplates.header') }}</h1>
      <p>{{ $t('editInspectionTemplates.line1') }}</p>
      <p>{{ $t('editInspectionTemplates.line2') }}</p>
    </div>
    <div>
      <transition-group class="template-list" name="list" tag="div">
        <div v-for="template in currentProjectInspectionTemplates" :key="template._id" class="template-icon">
          <locale-text :text="template.title" />
          <div class="sections">
            <div v-for="section in activeSections(template.sections)" :key="section._id" class="section">
              {{ section.title }}
            </div>
          </div>
          <div class="template-menu">
            <router-link
              :to="{
                name: 'EditInspectionTemplate',
                params: { _id: currentProject._id, inspectionTemplateId: template._id },
              }"
            >
              <div class="template-menu-contents">
                {{ $t('Edit') }}
              </div>
            </router-link>
          </div>
        </div>
        <div key="new" class="template-icon">
          <span class="add">
            {{ $t('New Template') }}
          </span>
          <div class="sections" />
          <div class="template-menu">
            <div class="template-menu-contents" @click="createInspectionTemplate">
              {{ $t('Create') }}
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import LocaleText from '@/components/common/LocaleText';

export default {
  name: 'EditInspectionTemplates',

  components: { LocaleText },

  metaInfo() {
    return {
      title: this.$t('Inspection Templates'),
    };
  },

  computed: {
    ...mapGetters(['currentProject', 'currentProjectInspectionTemplates']),
  },

  methods: {
    ...mapActions(['addInspectionTemplate']),

    async createInspectionTemplate() {
      const template = await this.addInspectionTemplate({ projectId: this.currentProject._id });
      this.$router.push({
        name: 'EditInspectionTemplate',
        params: {
          _id: this.currentProject._id,
          inspectionTemplateId: template._id,
        },
      });
    },

    activeSections: function (sections) {
      return sections.filter((section) => !section.archived);
    },
  },
};
</script>

<style scoped>
.edit-inspection-templates {
  color: #fff;
  padding: 20px;
  min-height: 100vh;
}

.add {
  cursor: pointer;
}

.template-list {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.template-icon {
  width: 15vw;
  height: 10vw;
  overflow: hidden;
  color: white;
  padding: 10px;
  margin: 10px;
  text-align: center;
  position: relative;
  border: 2px solid #343a40;
  border-radius: 10px;
  background: #ffffff05;
  white-space: nowrap;
}

.template-icon:hover .template-menu {
  display: block;
}

.template-menu {
  display: none;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
}

.template-menu-contents {
  top: 50%;
  position: relative;
  line-height: 17px;
  transform: translateY(-50%);
  padding: 15px;
  cursor: pointer;
}

.sections {
  width: 10vw;
  height: 7vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-around;
  margin: 5px auto;
  color: grey;
}

.section {
  font-size: 2pt;
  overflow: hidden;
  white-space: nowrap;
  width: 2vw;
  height: 1.3vw;
  margin: 2px;
  border: 0.5px solid #343a40;
  border-radius: 3px;
  background: #ffffff05;
}
</style>



// WEBPACK FOOTER //
// src/components/project/EditInspectionTemplates.vue